<script setup lang="ts">
import type { PrimitivesValue } from '../../types/shared'
import type { TabsInjection } from './types'
import { APP_TABS_KEY } from './constants'

type Props = {
  value: PrimitivesValue
}

const props = defineProps<Props>()

const attrs = useAttrs()

const component = computed(() => {
  if (attrs.href) return 'a'

  if (attrs.to) return resolveComponent('NuxtLink')

  return 'button'
})

const isSelected = computed(() => {
  if (attrs.to && typeof attrs.to === 'string') {
    return String(injection?.selectedValue.value).startsWith(
      String(props.value),
    )
  }

  return injection?.selectedValue.value === props.value
})

const tabIndex = computed(() => {
  return isSelected.value ? -1 : 0
})

const onClick = () => injection?.updateValue(props.value)

const injection = inject<TabsInjection>(APP_TABS_KEY)
</script>

<template>
  <component
    :is="component"
    class="app-tab"
    :class="{ 'app-tab--selected': isSelected }"
    v-bind="$attrs"
    role="tab"
    type="button"
    :aria-selected="isSelected"
    :tabindex="tabIndex"
    @click="onClick"
  >
    <slot />
  </component>
</template>

<style lang="scss" scoped>
.app-tab {
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  letter-spacing: -0.01em;
  white-space: nowrap;
}
</style>
